import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const ScriptsModalSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const nameLength = t('common.formErrorMessages.name_length');
  const nameRequired = t('common.formErrorMessages.name_required');
  const listType = t('common.formErrorMessages.list_type_required');
  const contentLength = t('common.formErrorMessages.content_length');
  const contentRequired = t('common.formErrorMessages.content_required');

  const schema = yup
    .object({
      name: yup.string().trim().max(50, nameLength).required(nameRequired),
      type: yup
        .object()
        .nullable()
        .required(listType)
        .shape({
          value: yup.string().required(listType),
          label: yup.string().required(listType),
        }),
      content: yup
        .string()
        .trim()
        .max(5000, contentLength)
        .required(contentRequired),
    })
    .required();

  return schema;
};

export default ScriptsModalSchema;
